export const BASE_PATH = '/'

export const LOGIN_PAGE = `/login`
export const USER_MANAGEMENT = `/user-management`
export const SETTINGS = `/settings`
